<template>
  <div class="teacherDetail">
    <div class="head">
      <div class="article">
        <div class="teacherCard">
          <div class="avatar">
            <img
              class="img"
              :src="info.userPicUrl"
              alt=""
              style="object-fit: cover"
            />
            <!-- <el-image class="img" :src="info.userPicUrl" fit="cover"></el-image> -->
            <div class="tip" v-if="info.isRecommend">
              <span class="txt">{{ $t('common.recommend') }}</span>
            </div>
          </div>
          <div class="btns" v-if="user.userType === 10">
            <router-link
              v-if="user.state === 1"
              :to="{ path: '/user/news', query: { id: info.teacherId } }"
              class="ui-btn blue"
              style="word-break: normal"
              >{{ $t('call') }}</router-link
            >
            <div
              v-else
              class="ui-btn blue"
              @click="notReviewedTip = true"
              style="cursor: pointer"
            >
              {{ $t('call') }}
            </div>
            <router-link
              :to="{
                path: '/teachers/appointment',
                query: { id: info.teacherId },
              }"
              style="word-break: normal"
              class="ui-btn"
              v-if="user.state === 1"
              >{{ $t('common.order') }}</router-link
            >
            <div
              v-else
              class="ui-btn"
              @click="notReviewedTip = true"
              style="cursor: pointer"
            >
              {{ $t('common.order') }}
            </div>
            <el-dialog :visible.sync="notReviewedTip" width="30%">
              <span>{{ $t('common.notReviewedTip') }}</span>
            </el-dialog>
            <!--               v-if="user.loginState && user.state!==0" -->
            <!-- <a @click="goOrder" class="ui-btn">{{ $t('common.order') }}</a> -->
          </div>
          <div class="info">
            <p class="name">{{ info.teacherName }}</p>
            <p>
              <span class="tag" v-if="info.teacherLevel === 1">{{
                $t('common.Standard')
              }}</span>
              <span class="tag" v-if="info.teacherLevel === 2">{{
                $t('common.Higher')
              }}</span>
              <span class="tag" v-if="info.teacherLevel === 3">{{
                $t('common.Super')
              }}</span>
              <a
                class="collected"
                :class="info.isFollow === 0 ? '' : 'focus'"
                v-if="user.loginState && user.userType === 10"
                @click="follow"
              ></a>
            </p>
            <!-- <p><span class="lab">{{$t("form.language")}}：</span>{{info.languageList}}</p> -->
            <p>
              <span class="lab"
                >{{ $t('form.univercity') }}{{ $t('colon') }}</span
              >{{
                !!info.universitys ? info.universitys.replace(',', ', ') : ''
              }}
            </p>
            <p>
              <span class="lab">{{ $t('form.college') }}{{ $t('colon') }}</span
              >{{ !!info.colleges ? info.colleges.replace(',', ', ') : '' }}
            </p>
            <!-- <p><span class="lab">{{$t("form.education")}}：</span>{{getEducation(info.education)}}</p> -->
            <p>
              <span class="lab" style="float: left"
                >{{ $t('form.present') }}{{ $t('colon') }}</span
              ><span
                style="
                  overflow: hidden;
                  display: block;
                  position: relative;
                  left: 3px;
                "
              >
                {{ info.presentCapacity }}</span
              >
            </p>
            <p>
              <span class="lab"
                >{{ $t('form.background') }}{{ $t('colon') }}</span
              >{{ info.teachingExperience }} {{ $t('year') }}
            </p>
            <p v-if="info.commentStar">
              <span class="lab">{{ $t('form.rating') }}{{ $t('colon') }}</span
              ><el-rate
                class="rate"
                v-model="info.commentStar"
                disabled
                show-score
                text-color="#ff9900"
                score-template="{value}"
              ></el-rate>
            </p>
          </div>
          <div class="whatsapp">
            <a
              v-if="$i18n.locale === 'en'"
              class="whatsapp-img"
              href="https://api.whatsapp.com/send?phone=+85292607280"
            >
              <img src="../assets/free with this tutor_eng.png" alt="" />
            </a>
            <a
              v-if="$i18n.locale === 'cn'"
              class="whatsapp-img"
              href="https://api.whatsapp.com/send?phone=+85292607280"
            >
              <img src="../assets/free with this tutor_sCN.png" alt="" />
            </a>
            <a
              v-if="$i18n.locale === 'TW'"
              class="whatsapp-img"
              href="https://api.whatsapp.com/send?phone=+85292607280"
            >
              <img src="../assets/free with this tutor_TCN.png" alt="" />
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="article">
      <ul class="tabs" id="video">
        <li :class="tab === 0 ? 'on' : ''" @click="tab = 0">
          {{ $t('detail') }}
        </li>
        <!-- <li :class="tab === 1 ? 'on' : ''" @click="tab = 1">资质证书</li> -->
        <li
          :class="tab === 2 ? 'on' : ''"
          @click="tab = 2"
          v-if="info.introductoryVideoUrl"
        >
          {{ $t('video') }}
        </li>
      </ul>
      <div class="content" v-show="tab === 0">
        <h3 class="title">{{ $t('form.subject2') }}</h3>
        <!-- {{info.taughtSubjects}} -->
        <p>{{ getSubject(info.taughtSubjects) }}</p>
        <h3 class="title">{{ $t('self') }}</h3>
        <p>{{ info.introduction }}</p>
        <h3 class="title">{{ $t('form.achievements') }}</h3>
        <p style="margin-bottom: 20px">{{ info.achievements }}</p>
        <div style="text-align: center">
          <a
            v-if="$i18n.locale === 'en'"
            class="whatsapp-img"
            href="https://api.whatsapp.com/send?phone=+85292607280"
          >
            <img src="../assets/free with this tutor_eng.png" alt="" />
          </a>
          <a
            v-if="$i18n.locale === 'cn'"
            class="whatsapp-img"
            href="https://api.whatsapp.com/send?phone=+85292607280"
          >
            <img src="../assets/free with this tutor_sCN.png" alt="" />
          </a>
          <a
            v-if="$i18n.locale === 'TW'"
            class="whatsapp-img"
            href="https://api.whatsapp.com/send?phone=+85292607280"
          >
            <img src="../assets/free with this tutor_TCN.png" alt="" />
          </a>
        </div>
      </div>
      <div class="content" v-show="tab === 1">
        <ul class="list" v-if="info.identityProof.length">
          <li v-for="(item, index) in info.identityProof" :key="index">
            <img :src="item" alt="" />
          </li>
        </ul>
        <div v-else>
          <!-- 暂无数据 -->
          <div class="ui-empty"></div>
        </div>
      </div>
      <div class="content" v-show="tab === 2">
        <ul class="list video" v-if="info.introductoryVideoUrl">
          <li><video :src="info.introductoryVideoUrl" controls></video></li>
          <li>
            <a
              v-if="$i18n.locale === 'en'"
              class="whatsapp-img"
              href="https://api.whatsapp.com/send?phone=+85292607280"
            >
              <img src="../assets/free with this tutor_eng.png" alt="" />
            </a>
            <a
              v-if="$i18n.locale === 'cn'"
              class="whatsapp-img"
              href="https://api.whatsapp.com/send?phone=+85292607280"
            >
              <img src="../assets/free with this tutor_sCN.png" alt="" />
            </a>
            <a
              v-if="$i18n.locale === 'TW'"
              class="whatsapp-img"
              href="https://api.whatsapp.com/send?phone=+85292607280"
            >
              <img src="../assets/free with this tutor_TCN.png" alt="" />
            </a>
          </li>
        </ul>
        <div v-else>
          <!-- 暂无数据 -->
          <!-- <div class="ui-empty"></div> -->
        </div>
      </div>
    </div>
    <guide />
  </div>
</template>
<script>
import card from '@/components/TeacherCard.vue'
import guide from '@/components/RegistGuide.vue'
import {
  getBaseProfile,
  followTeacher,
  cancelFollow,
} from '@/service/teacherApi.js'
export default {
  components: { card, guide },
  data() {
    return {
      tab: 0,
      info: { identityProof: [], taughtSubjects: [] },
      id: '',
      notReviewedTip: false,
    }
  },
  methods: {
    goAnchor() {
      this.$el.querySelector('#video').scrollIntoView();
    },
    getEducation(n) {
      switch (n) {
        case 1:
          return this.$t('education.level1')
          break
        case 2:
          return this.$t('education.level2')
          break
        case 3:
          return this.$t('education.level3')
          break
        case 4:
          return this.$t('education.level4')
          break
        case 5:
          return this.$t('education.level5')
          break
        case 6:
          return this.$t('education.level6')
          break
      }
    },
    async getBaseProfile() {
      try {
        let res = await getBaseProfile({ teacherId: this.$route.query.id })
        if (res.data.status === 1) {
          this.info = res.data.data
          // this.info.identityProof = this.info.identityProof.split('$_$')
        } else {
          this.$message.error(res.data.descript)
        }
      } catch (error) {
        this.$message.error(this.$t('Systemerror') + error.message)
      }
    },
    goOrder() {
      if (this.user.loginState) {
        this.$router.push({
          path: '/teachers/appointment',
          query: { id: this.$route.query.id },
        })
      } else {
        this.$router.push({ path: '/login' })
      }
    },
    getSubject(arr2) {
      let arr = JSON.parse(JSON.stringify(arr2))
      arr = arr.sort(function (a, b) {
        let nameA = a.subjectName.toUpperCase()
        let nameB = b.subjectName.toUpperCase()
        if (nameA < nameB) {
          return -1
        }
        if (nameA > nameB) {
          return 1
        }
        return 0
      })
      let name = ''

      let newArr = []
      let arrId = []
      for (let item of arr) {
        if (arrId.indexOf(item['subjectName']) == -1) {
          arrId.push(item['subjectName'])
          newArr.push(item)
        }
      }
      for (let i = 0; i < newArr.length; i++) {
        if (i != 0) {
          name += '\n '
        }
        // console.log(newArr[i].subjectName);
        // console.log(newArr[i]);
        // newArr[i].courseName+'\n'+
        name += newArr[i].subjectName
        if (newArr[i].mark) {
          name += ': ' + newArr[i].mark
        }
      }
      return name
    },
    async follow() {
      let res
      if (this.info.isFollow === 0) {
        res = await followTeacher({ teacherId: this.$route.query.id })
      } else {
        res = await cancelFollow({ teacherId: this.$route.query.id })
      }
      if (res.data.status === 1) {
        if (this.info.isFollow === 0) {
          this.info.isFollow = 1
          this.$message({ message: this.$t('FollowedTutor'), type: 'success' })
        } else {
          this.info.isFollow = 0
          this.$message({ message: this.$t('UnfollowedTutor'), type: 'success' })
        }
      }
    },
  },
  mounted() {
    this.tab = !!this.$route.query.tab ? this.$route.query.tab : this.tab;
    if (!!this.$route.query.tab) {
      this.goAnchor();
    }
    this.getBaseProfile()
  },
  computed: {
    user() {
      return JSON.parse(this.$store.getters.GETUSER)
    },
  },
}
</script>
<style lang="scss" scoped>
.whatsapp{
  position: relative;
  top: 34px;
}
.whatsapp-img {
  img {
    width: 320px;
  }
}
.head {
  background: #fff;
  padding: 30px 0 0px;
  box-shadow: 0 6px 14px rgba($color: #000, $alpha: 0.05);
}
.tabs {
  overflow: hidden;
  margin-top: 40px;
  padding-left: 30px;
  li {
    float: left;
    height: 42px;
    width: 180px;
    border-radius: 12px 12px 0 0;
    line-height: 42px;
    text-align: center;
    background: #a9c4b1;
    color: #fff;
    margin-right: 10px;
    cursor: pointer;
    transition: background 0.3s;
    &:hover {
      background: darken(#a9c4b1, 10%);
    }
    &.on {
      background: #002147;
    }
  }
}
.content {
  background: #fff;
  padding: 20px 80px 100px;
  margin-bottom: 90px;
  box-shadow: 0 6px 12px rgba($color: #000000, $alpha: 0.05);
  white-space: pre-line;
  .title {
    font-size: 21px;
    margin-top: 40px;
  }
  p {
    margin-top: 19px;
    line-height: 24px;
    font-size: 16px;
    color: #555;
  }
}
.list {
  img {
    max-width: 100%;
  }
  li {
    margin-top: 40px;
    text-align: center;
    font-size: 0;
    position: relative;
  }
}
.video {
  video {
    width: 100%;
    height: 528px;
  }
}
.teacherCard {
  overflow: hidden;
  padding: 30px;
}
.avatar {
  float: left;
  width: 320px;
  height: 320px;
  position: relative;
  font-size: 0;
  margin-right: 50px;
  .img {
    width: 100%;
    height: 100%;
  }
}
// .tip{
//   position: absolute; top: -12px; right: -15px; width: 111px; height: 111px; background: url(../assets/triangle2.png); text-align: center;
//   .txt{display: inline-block; font-size: 21px; transform: rotate(45deg); color: #fff; transform-origin: 0 141%;}
// }
.btns {
  float: right;
  width: 236px;
  padding: 26px 0 0 30px;
  text-align: left;
  margin-top: 33px;
  height: 267px;
  border-left: 1px solid #dcdcdc;
  text-align: center;
  .ui-btn {
    margin-top: 30px;
  }
}
.info {
  overflow: hidden;
  p {
    margin-bottom: 10px;
    font-size: 18px;
    color: #555;
  }
  .name {
    font-size: 48px;
    color: #002147;
    line-height: 64px;
  }
  .lab {
    color: #000;
  }
  .rate {
    display: inline-block;
  }
}
.tag {
  display: inline-block;
  margin: 0 30px 20px 0;
  padding: 0 16px;
  height: 24px;
  line-height: 24px;
  border-radius: 24px;
  background: #a9c4b1;
  color: #fff;
  font-size: 14px;
}
.collected {
  display: inline-block;
  vertical-align: middle;
  width: 32px;
  height: 32px;
  background: url(../assets/collect1.png);
  &.focus {
    background-image: url(../assets/collect2.png);
  }
}
</style>
<style lang="scss" scoped>
@media screen and (max-width: 768px) {
  .whatsapp{
  position: relative;
  top: 0;
}
  .whatsapp-img {
    img {
      width: 100%;
    }
  }
  .avatar {
    float: inherit;
  }
  .info {
    .name {
      // font-size: 5vw;
      font-size: 36px;
    }
  }
  .tabs {
    display: flex;
  }
  .content {
    padding: 20px;
  }
  .btns {
    display: none;
  }
  .teacherCard {
    padding: 20px;
  }
}
</style>
<i18n>
{
  "cn": {
    "Systemerror":"系统出问题了",
    "Favourite": "已关注",
    "Follow": "关注",
    "detail": "详情",
    "video": "视频资料",
    "self": "个人简介",
    "call": "咨询老师",
    "FollowedTutor":"关注老师成功",
    "UnfollowedTutor":"取消关注老师成功"
  },
  "TW": {
    "Systemerror":"系統出問題了",
    "Favourite": "已關注",
    "Follow": "關注",
    "detail": "詳情",
    "video": "視頻資料",
    "self": "個人簡介",
    "call": "諮詢老師",
    "FollowedTutor":"關注老師成功",
    "UnfollowedTutor":"取消關注老師成功"
  },
  "en": {
    "Systemerror":"System error",
    "Favourite": "Favourite",
    "Follow": "Follow",
    "detail": "Details",
    "video": "Video",
    "self": "Profile Summary",
    "call": "Message Tutor",
    "FollowedTutor":"Followed Tutor",
    "UnfollowedTutor":"Unfollowed Tutor"
  }
}
</i18n>